import React from "react";
import { Carousel } from "react-responsive-carousel";
import "react-responsive-carousel/lib/styles/carousel.min.css";

// import test1 from "../../assets/testimonials/testimonial_1.jpg";
import test1 from "../../assets/MInimalist landscape [1920x1080].png";
// import test2 from "../../assets/testimonials/testimonial_2.jpg";
// import test3 from "../../assets/testimonials/testimonial_3.jpg";

import "./Testimonial.css";

const testimonials = [
  {
    id: 1,
    src: test1,
    name: "John Doe",
    content:
      "This is the first testimonial. Lorem ipsum dolor sit amet, consectetur adipiscing elit.",
  },
  {
    id: 2,
    src: test1,
    name: "Jane Smith",
    content:
      "This is the second testimonial. Nulla facilisi. Vivamus sit amet odio et erat.",
  },
  {
    id: 3,
    src: test1,
    name: "Alice Johnson",
    content:
      "This is the third testimonial. Curabitur varius justo a metus luctus.",
  },
];

const Testimonials = () => {
  return (
    <div className="testimonial-section">
      <Carousel
        showArrows={true}
        autoPlay={true}
        interval={1500}
        infiniteLoop={true}
        showThumbs={false}
        showStatus={false}
        swipeable={true}
      >
        {testimonials.map((testimonial) => (
          <div
            key={testimonial.id}
            className="h-1/5 p-12 bg-slate-100 rounded-lg shadow-lg testi-img"
          >
            <img
              src={testimonial.src}
              alt={testimonial.name}
              className="testimonial-image"
              style={{
                maxHeight: "300px",
                width: "100%",
                objectFit: "cover",
                borderRadius: "12px",
              }}
            />

            <h3
              style={{
                marginTop: "16px",
                fontSize: "1.25rem",
                fontWeight: "600",
              }}
            >
              {testimonial.name}
            </h3>

            <p
              style={{
                marginTop: "12px",
                lineHeight: 1.6,
                color: "#334155",
              }}
            >
              {testimonial.content}
            </p>
          </div>
        ))}
      </Carousel>
    </div>
  );
};

export default Testimonials;